/* eslint-disable import/prefer-default-export */
import { chunk } from 'lodash';
import { get, post } from 'utils/methods';

export const JOBS_LIMIT = 50;

export function getJobApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_PP}jobs`, data, headers);
}

export async function getJobsByIdsApi(ids, data = {}, headers) {
    const jobIds = Array.isArray(ids) ? ids : [ids];

    if (jobIds.length === 0) {
        return {
            status: 200,
            data: {
                hits: [],
                total: 0,
            },
        };
    }

    const filter = data.filter ? JSON.parse(data.filter) : {};
    const responses = await Promise.all(chunk(jobIds, JOBS_LIMIT).map(idsChunk => getJobApi({
        ...data,
        filter: JSON.stringify({ ...filter, _id: idsChunk }),
        limit: JOBS_LIMIT,
        offset: 0,
    }, headers)));
    const failedResponse = responses.find(response => response.status !== 200);

    if (failedResponse) {
        return failedResponse;
    }

    const hits = responses.flatMap(response => response.data?.hits || []);

    return {
        ...responses[0],
        data: {
            ...responses[0].data,
            hits,
            total: hits.length,
        },
    };
}

export function toggleJobStatusApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/job/status`, data, headers);
}

export function addJobErrorApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/error`, data, headers);
}
